import { format } from "date-fns";

export default function ArmadoCard({numberDocument, clientName, dateSend, dateReception}){

    const handleArmado = (e) => {
        console.log(e.target.value)
    }


    return (
        <div className="flex flex-row text-[8pt]">
            <div className="w-14 text-center">{numberDocument}</div>
            <div className="w-60 pl-2">{clientName}</div>
            <div className="w-24 text-center">{dateSend ? format(new Date(dateSend), "dd/MM/yyyy") : null}</div>
            <div className="w-24 text-center">{dateReception ? format(new Date(dateReception), "dd/MM/yyyy") : null}</div>
            <div className="w-14 text-center"><button value={numberDocument} onClick={handleArmado}>Entrega</button></div>
        </div>
    )

}